<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      :upload-before="uploadBefore"
      :upload-error="uploadError"
      :upload-after="uploadAfter"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="infoForm" slot-scope="scope">
        <avue-crud :option="infoOption" :data="infoData"></avue-crud>
      </template>
      <template slot-scope="scope" slot="carNoForm">
        <el-autocomplete
          style="width: 100%"
          v-model="form.carNo"
          :debounce="1000"
          @input="carNohandleBlur"
          placeholder="请输入车牌号"
          :trigger-on-focus="true"
          :disabled="dialogDisabled"
          :fetch-suggestions="queryCarPayMonthCarNo"
          @select="selectCarPayCarNo"
        ></el-autocomplete>
      </template>
      <template slot-scope="scope" slot="spaceIdForm">
        <el-select
          :disabled="dialogDisabled"
          v-model="form.spaceId"
          filterable
          placeholder="请选择停车场"
          style="width: 100%"
          @input="selectSpace"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-row :span="24" style="width: 500px">
          <el-col :span="4">待审核 {{ statusCount.toAuditNum }}</el-col>
          <el-col :span="4">待付款 {{ statusCount.toPayNum }}</el-col>
          <el-col :span="4">正常 {{ statusCount.normalNum }}</el-col>
          <el-col :span="4">已过期 {{ statusCount.expiredNum }}</el-col>
        </el-row>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          size="small"
          plain
          v-if="scope.row.status === 2 && permissionList.payBtn"
          @click="handlePayCarMonth(scope.row, 0)"
          >付 款
        </el-button>
        <el-button
          size="small"
          plain
          v-else-if="scope.row.status !== 1 && permissionList.contractBtn"
          @click="handlePayCarMonth(scope.row, 1)"
          >续 约
        </el-button>
        <!--        <el-button-->
        <!--          size="small"-->
        <!--          plain-->
        <!--          v-if="scope.row.status === 3"-->
        <!--          @click="openCarMonthChangeDialog(scope.row)"-->
        <!--        >-->
        <!--          更 牌-->
        <!--        </el-button>-->
        <el-button
          size="small"
          plain
          v-if="scope.row.status === 3 && permissionList.refundBtn"
          @click="openCarMonthRefundDialog(scope.row)"
        >
          退 款
        </el-button>
        <el-button
          size="small"
          plain
          v-if="scope.row.status === 1 && permissionList.editBtn"
          @click="openCarMonthEditDialog(scope.row)"
        >
          修 改
        </el-button>
        <el-button
          size="small"
          plain
          v-if="scope.row.status === 1 && permissionList.auditBtn"
          @click="openCarMonthReviewDialog(scope.row)"
        >
          审 核
        </el-button>
        <el-button
          size="small"
          plain
          v-if="scope.row.status === 5 && permissionList.delBtn"
          @click="openCarMonthDeleteDialog(scope.row)"
        >
          删 除
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="修改"
      :visible.sync="carMonthEditShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthEditForm"
          :option="carMonthEditOption"
          @reset-change="carMonthEditReset"
          @submit="carMonthEditSubmit"
        >
          <template slot="roomId">
            <el-input readonly v-model="carMonthReviewForm.areaName">
              <el-button slot="append" @click="editRoomSelectionOpen">选择</el-button>
            </el-input>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="carMonthReviewShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthReviewFormRef"
          v-model="carMonthReviewForm"
          :option="carMonthReviewOption"
          @reset-change="carMonthReviewReset"
          @submit="carMonthReviewSubmit"
        >
          <template slot="roomId">
            <el-input readonly v-model="carMonthReviewForm.areaName">
              <el-button slot="append" @click="reviewRoomSelectionOpen">选择</el-button>
            </el-input>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthReviewDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="车牌变更"
      :visible.sync="carMonthChangeShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthChangeDialogOpened"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthChangeFormRef"
          v-model="carMonthChangeForm"
          :option="carMonthChangeOption"
          @reset-change="carMonthChangeReset"
          @submit="carMonthChangeSubmit"
        >
          <template slot-scope="scope" slot="newCarNo">
            <el-autocomplete
              style="width: 100%"
              v-model="carMonthChangeForm.newCarNo"
              :debounce="1000"
              placeholder="请输入车牌号"
              :trigger-on-focus="true"
              :disabled="dialogDisabled"
              :fetch-suggestions="changeQueryCarPayMonthCarNo"
              @select="changeSelectCarPayCarNo"
            ></el-autocomplete>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthChangeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="退租"
      :visible.sync="carMonthRefundShowDialogFlag"
      :modal-append-to-body="false"
      @opened="carMonthRefundDialogOpened"
      @close="quitCarMonthRefundDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthRefundFormRef"
          v-model="carMonthRefundForm"
          :option="carMonthRefundOption"
          @reset-change="carMonthRefundReset"
          @submit="carMonthRefundSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthRefundDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog title="按条件导出" append-to-body :visible.sync="exportExcelFlag">
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="月卡车复制"
      :visible.sync="carMonthCopyShowDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="carMonthCopyFormRef"
          v-model="carMonthCopyForm"
          :option="carMonthCopyOption"
          @reset-change="carMonthCopyReset"
          @submit="carMonthCopySubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarMonthCopyDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <carMonthExport
      ref="carMonthExport"
      v-bind:spaceList="spaceList"
      v-bind:statusList="statusList"
      v-bind:carTypeList="carTypeList"
    >
    </carMonthExport>
    <el-dialog
      title="临停车欠费记录"
      append-to-body
      :visible.sync="tempStopUnPayDialogFlag"
      @closed="closeDialog"
    >
      <avue-crud :option="unPayOption" :data="unPayData" ref="unPayFormRef" />
    </el-dialog>
    <el-dialog :title="payFormTitle" append-to-body :visible.sync="showMonthCarPayFlag">
      <avue-form
        ref="carMonthCardPayForm"
        v-if="showMonthCarPayFlag"
        v-model="carMonthCardPayForm"
        :option="carMonthPayFormOption"
      >
        <template slot="payType">
          <el-select v-model="carMonthCardPayForm.payType" @change="payTypeChange">
            <el-option
              v-for="item in payTypeList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="cycleNum">
          <el-input
            type="number"
            v-if="operateType === 1"
            v-model="carMonthCardPayForm.cycleNum"
            @input="cycleNumInput"
          ></el-input>
        </template>

        <template slot="payScene">
          <el-select v-model="carMonthCardPayForm.payScene" @change="paySceneChange">
            <el-option
              v-for="item in paySceneList"
              :key="item"
              :value="item.dictKey"
              :label="item.dictValue"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="authCode">
          <!-- v-if="showAuthCodeFlag" -->
          <el-input
            type="password"
            ref="authCodeInput"
            v-model="carMonthCardPayForm.authCode"
            @blur="blurHandler"
            @input="inputHandler"
            @focus="focusHandler"
            maxlength="18"
            placeholder="请输入收款码"
          ></el-input>
        </template>

        <template slot="buildingId">
          <avue-input-tree
            node-key="value"
            :props="defaultPropsBuilding"
            default-expand-all
            v-model="carMonthCardPayForm.buildingId"
            placeholder="请选择楼栋/单元"
            type="select"
            @change="buildingIdChange"
            :dic="buildingList"
          >
          </avue-input-tree>
        </template>

        <template slot="roomId">
          <el-input readonly v-model="carMonthCardPayForm.areaName">
            <el-button slot="append" @click="roomSelectionOpen">选择</el-button>
          </el-input>
          <!-- <avue-input-tree
          disabled
              @click="roomSelectionOpen"
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthCardPayForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
          >
          </avue-input-tree> -->
        </template>
      </avue-form>
      <div style="padding: 1rem; overflow: hidden">
        <div style="float: right">
          <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
          <el-button @click="cancelPay" type="normal">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="payScene == 6 ? '查询中' : '收款码'"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="roomSelectionShowBoxFlag">
      <!-- v-model="carMonthCardPayForm" -->
      <!-- <avue-form
        ref="roomSelectionForm"
        v-if="roomSelectionShowBoxFlag"
        v-model="roomSelectionForm"
        :option="roomSelectionFormOption"
      > -->
      <!-- <template slot="buildingId"> -->
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthCardPayForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthCardPayForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <!-- </template> -->
        <div style="height: 1rem"></div>
        <!-- <template slot="roomId"> -->
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthCardPayForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <!-- </template> -->
      <!-- </avue-form> -->
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="confirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="房间" append-to-body :visible.sync="reviewRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthReviewForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthReviewForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthReviewForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="reviewConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="房间" append-to-body :visible.sync="editRoomSelectionShowBoxFlag">
      <div style="display: table; margin: 0 auto">
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">小区:</div>
          <div style="display: table-cell">
            <el-input disabled v-model="carMonthEditForm.communityName"></el-input>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">楼栋:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsBuilding"
              default-expand-all
              v-model="carMonthEditForm.buildingId"
              placeholder="请选择楼栋/单元"
              type="select"
              @change="buildingIdChange"
              :dic="buildingList"
            >
            </avue-input-tree>
          </div>
        </div>
        <div style="height: 1rem"></div>
        <div style="display: table-row">
          <div style="display: table-cell; width: 3rem">房间:</div>
          <div style="display: table-cell">
            <avue-input-tree
              node-key="value"
              :props="defaultPropsRoom"
              default-expand-all
              v-model="carMonthEditForm.roomId"
              placeholder="请选择房号"
              type="select"
              @change="targetIdChange"
              :dic="targetList"
            >
            </avue-input-tree>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding: 1rem 0">
        <el-button @click="editConfirmRoomSelection" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <t-printPreview ref="printPreview"></t-printPreview>
  </basic-container>
</template>
<script>
import QRCode from 'qrcodejs2';
import NP from 'number-precision';
import {
  saveCarQrCodePay,
  saveCarBarCodePay,
  loadCarPayStatus,
  monthcarStatusCount,
  getMonthcarList,
  getParkSpaceList,
  getMonthcarDetail,
  deleteCarMonth,
} from '@/api/v4ward/carv2/carcharge';

import { loadZhxx, saveAllBill } from '@/api/charge';
import {
  getPayTypeList,
  getPaySceneList,
  loadPayStatusPlatform,
  loadBuildingList,
  loadRoomList,
} from '@/api/charge/charge-pay';
import {
  addRenior,
  getDetailAndOperate,
  getcarMonthLastEndTime,
  getList,
  remove,
  synchronize,
  update,
  loadCarPayBackAmount,
  loadCarPayAmount,
  getDetail,
  copyCarmonth,
  loadCarPayMonthCarNo,
  nodeTreeByParentId,
  getListTempStopUnPayList,
} from '@/api/v4ward/carv2/carmonth';
import { monthChargeRuleList } from '@/api/v4ward/carv2/carmonthchargerule';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { lazyBasePropertyTree } from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';
import carMonthRenewOption from './carmonth-renew-option';
import carMonthReviewOption from './carmonth-review-option';
import carMonthEditOption from './carmonth-edit-option';
import exportExcelOption from './carmonth-exportExcel';
import carMonthPayOption from './carmonth-pay-option';
import carMonthChangeOption from './carmonth-change-option';
import carMonthRefundOption from './carmonth-refund-option';
import carMonthExport from './carMonthExport';
import carMonthCopyOption from './carmonthRenior-copyCarmonth';
import carMonthPayFormOption from './carmonthCharge';
import dayjs from 'dayjs';
import { getDetailById } from '@/api/v4ward/carv2/carpark';

export default {
  data() {
    return {
      roomSelectionShowBoxFlag: false,
      reviewRoomSelectionShowBoxFlag: false,
      editRoomSelectionShowBoxFlag: false,
      operateType: 0,
      zhxx: [],
      paySceneList: [],
      targetList: [],
      buildingList: [],
      payTypeList: [],
      payInfo: {},
      payInfo2: {
        showQrCode: false,
        tradeStatus: '',
        countdown: '',
      },
      carMonthCardPayForm: {},
      carMonthPayFormOption: carMonthPayFormOption,
      showMonthCarPayFlag: false,
      statusCount: {
        expiredNum: 0, //已过期
        normalNum: 0, //正常
        toAuditNum: 0, //待审核
        toPayNum: 0, //待付款
      },
      dialogDisabled: false,
      reWrite: false,
      exportExcelFlag: false,
      exportExcelOption: exportExcelOption,
      exportExcelForm: {},
      tempStopUnPayDialogFlag: false,
      areaName: '',
      refundCheckBuyEndTime: true,
      refundCheckReturnMoney: true,

      iscarMonthRenewDialogFirstOpen: true,
      carMonthRenewShowDialogFlag: false,
      carMonthRenewForm: {},
      carMonthRenewOption: carMonthRenewOption,

      iscarMonthReviewDialogFirstOpen: true,
      carMonthReviewShowDialogFlag: false,
      carMonthReviewForm: {},
      carMonthReviewOption: carMonthReviewOption,

      iscarMonthEditDialogFirstOpen: true,
      carMonthEditShowDialogFlag: false,
      carMonthEditForm: {},
      carMonthEditOption: carMonthEditOption,

      iscarMonthPayDialogFirstOpen: true,
      carMonthPayShowDialogFlag: false,
      carMonthPayForm: {},
      carMonthPayOption: carMonthPayOption,

      iscarMonthChangeDialogFirstOpen: true,
      carMonthChangeShowDialogFlag: false,
      carMonthChangeForm: {},
      carMonthChangeOption: carMonthChangeOption,

      iscarMonthRefundDialogFirstOpen: true,
      carMonthRefundShowDialogFlag: false,
      carMonthRefundForm: {},
      carMonthRefundOption: carMonthRefundOption,

      iscarMonthCopyDialogFirstOpen: true,
      carMonthCopyShowDialogFlag: false,
      carMonthCopyForm: {},
      carMonthCopyOption: carMonthCopyOption,
      regionFirstIdTemp: '',
      addFlag: false,

      buyStartTimeTemp: '',
      buyEndTimeTemp: '',

      form: {},
      query: {
        spaceId: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      carNoList: [],
      selectionList: [],
      spaceList: [],
      statusList: [],
      carTypeList: [],
      firstDisplayFlag: false,
      tempSpaceId: '',
      option: {
        addBtn: false,
        height: 'auto',
        searchShow: true,
        searchMenuSpan: 6,
        calcHeight: 120,
        align: 'center',
        indexLabel: '序号',
        tip: false,
        border: true,
        index: true,
        // viewBtn: true,
        viewBtn: false,
        editBtn: false,
        // delBtn: true,
        delBtn: false,
        selection: true,
        menuWidth: 200,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            formslot: true,
            editDisabled: false,
            clearable: false,
            span: 8,
            search: true,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },
          {
            label: '区域',
            prop: 'regionsName',
            span: 8,
            display: false,
          },

          {
            label: '车牌号',
            prop: 'carNo',
            search: true,
            editDisabled: true,
            formslot: true,
            filterable: false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请选择车牌号',
                trigger: 'change',
              },
              {
                pattern: this.$validation.carPlate,
                message: '车牌号格式错误',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '通行区域',
            prop: 'regions',
            hide: true,
            span: 8,
            type: 'tree',
            multiple: true,
            checkStrictly: true,
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择通行区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆分类',
            span: 8,
            hide: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择车辆分类',
                trigger: 'change',
              },
            ],
            dataType: 'number',
            prop: 'carClass',
          },
          {
            label: '车辆类型',
            span: 8,
            hide: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请选择车辆类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上次止期',
            prop: 'lastEndTime',
            span: 8,
            width: 100,
            type: 'date',
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            disabled: true,
          },
          {
            label: '欠费金额',
            prop: 'backAmount',
            editDisplay: false,
            viewDisplay: false,
            disabled: true,
            hide: true,
            span: 8,
            click: ({ value, column }) => {
              let spaceId = this.form.spaceId;
              let carNo = this.form.carNo;
              if (value > 0) {
                this.selectTempStopUnPayList(spaceId, carNo);
              }
            },
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',
            span: 8,
            width: 100,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            rules: [
              {
                required: true,
                message: '请输入租赁起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费套餐',
            prop: 'ruleName',
            hide: true,
            display: false,
            addDisplay: false,
          },
          {
            label: '收费套餐',
            prop: 'ruleId',
            type: 'tree',
            hide: true,
            disabled: true,
            dicData: [],
            props: {
              label: 'remark',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择收费套餐',
                trigger: 'blur',
              },
            ],
            span: 8,
          },
          {
            label: '续租时长',
            prop: 'cycleNum',
            span: 8,
            disabled: true,
            viewDisplay: false,
            hide: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            type: 'date',
            width: 100,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入租赁止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.buyStartTime);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('租赁止期必须大于租赁起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '应收金额',
            prop: 'shouldMoney',
            precision: 2,
            width: 70,
            hide: true,
            maxlength: 15,
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            rules: [
              /*              {
                              required: true,
                              message: '请填入应收金额',
                              trigger: 'change',
                            },*/
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
            minRows: 0.01,
            span: 8,
          },
          {
            label: '支付金额',
            prop: 'payMoney',
            width: 70,
            span: 8,
            precision: 2,
            maxlength: 15,
            showWordLimit: true,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0.01,
            rules: [
              /*              {
                              required: true,
                              message: '请填入支付金额',
                              trigger: 'change',
                            },*/
              { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
            ],
          },
          {
            label: '客户姓名',
            span: 8,
            prop: 'customerName',
            width: 70,
            search: true,
            maxlength: 10,
            disabled: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入客户姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '客户手机',
            prop: 'customerPhone',
            search: true,
            width: 100,
            span: 8,
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            search: true,
            width: 70,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            span: 8,
            editDisplay: false,
            addDisplay: false,
            rules: [
              {
                message: '请输入同步标识  0未同步  1已同步',
                trigger: 'change',
              },
            ],
          },
          //   {
          //     label: '支付方式',
          //     addDisplay: false,
          //     editDisplay: false,
          //     prop: 'payType',
          //     disabled: true,
          //     span: 8,
          //     type: 'select',
          //     dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
          //     props: {
          //       label: 'dictValue',
          //       value: 'dictKey',
          //     },
          //     dataType: 'number',
          //     rules: [
          //       {
          //         required: true,
          //         message: '请输入支付方式',
          //         trigger: 'change',
          //       },
          //     ],
          //   },
          //   {
          //     label: '支付时间',
          //     prop: 'payTime',
          //     span: 8,
          //     width: 150,
          //     type: 'date',
          //     display: false,
          //     format: 'yyyy-MM-dd HH:mm:ss',
          //     valueFormat: 'yyyy-MM-dd HH:mm:ss',
          //     editDisabled: true,
          //   },
          {
            label: '车位编号',
            prop: 'lotNo',
            hide: true,
            span: 8,
            disabled: true,
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: false,
                message: '请输入停车车位编号',
                trigger: 'change',
              },
            ],
          },
          {
            // 此column不展示，用做接受选择车牌后返回的房间id数据，新增后存入数据库
            //lazy: true,
            label: '房间',
            prop: 'areaId',
            type: 'tree',
            hide: true,
            span: 16,
            display: false,
            /*   props: {
              labelText: '标题',
              label: 'objectFullName',
              value: 'key',
              children: 'children',
            },
            treeLoad: function (node, resolve) {
              if (node.level === 0) {
                return;
              }
              const id = node.data.id;
              lazyBasePropertyTree(id).then((res) => {
                resolve(
                  res.data.map((item) => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },*/
          },
          {
            label: '房产',
            prop: 'areaName',
            span: 16,
            disabled: true,
          },
          {
            label: '电子资料',
            prop: 'imgUrl',
            hide: true,
            type: 'upload',
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            /*  canvasOption: {
              text: ' ',
              ratio: 0.1,
            },*/
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过500kb',
            span: 24,
            row: true,
          },
          {
            label: '备注',
            prop: 'remark1',
            type: 'textarea',
            hide: true,
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            minRows: 2,
            overHidden: true,
            rules: [
              {
                required: false,
                message: '办公车辆请输入备注说明',
                trigger: 'change',
              },
            ],
          },
          {
            addDisplay: false,
            editDisplay: false,
            label: '操作日志',
            prop: 'info',
            span: 24,
            hide: true,
            formslot: true,
          },
          {
            label: '租赁起期',
            prop: 'dateStartRange',
            span: 24,
            // search: true,
            search: false,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '结束日期',
            prop: 'dateEndRange',
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '剩余天数',
            prop: 'daysRemaining',
            search: true,
          },
          {
            label: '支付时间',
            prop: 'payTimeRange',
            searchSpan: 6,
            // search: true,
            search: false,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '审核备注',
            prop: 'remark2',
            type: 'textarea',
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            minRows: 2,
            overHidden: true,
          },
        ],
      },
      infoOption: {
        addBtn: false,
        menu: false,
        border: true,
        column: [
          {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            dicData: [
              {
                label: '月卡车审核',
                value: 1,
              },
              {
                label: '新增月卡车',
                value: 2,
              },
              {
                label: '修改月卡车',
                value: 6,
              },
              {
                label: '月卡车退费',
                value: 4,
              },
              /*  {
                label: '车辆续约',
                value: 5,
              },*/
              {
                label: '变更车牌',
                value: 3,
              },
              {
                label: '删除过期车辆',
                value: 7,
              },
              {
                label: '月卡车信息已同步至岗亭',
                value: 8,
              },
              {
                label: '补缴月卡车更新临停记录',
                value: 9,
              },
              /*  {
                label: '缴费成功新增失败',
                value: 11,
              },*/
            ],
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            width: 400,
          },
          {
            label: '操作人',
            width: 100,
            prop: 'remark3',
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },
        ],
      },
      unPayOption: {
        addBtn: false,
        menu: false,
        border: true,
        columnBtn: false,
        refreshBtn: false,
        align: 'center',
        column: [
          {
            label: '停车场',
            prop: 'spaceName',
            width: 110,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            width: 90,
          },
          {
            label: '欠费（元）',
            prop: 'bankMoney',
          },
          {
            label: '停车时长（时）',
            prop: 'parkTime',
          },
          {
            label: '入场时间',
            prop: 'inTime',
            searchSpan: 6,
            width: 130,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '出场时间',
            prop: 'outTime',
            type: 'datetimerange',
            searchRange: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 130,
          },
          {
            label: '应缴（元）',
            prop: 'payableMoney',
          },
          {
            label: '实收（元）',
            prop: 'chargeMoney',
          },
        ],
      },
      unPayData: [],
      data: [],
      payFormTitle: '',
    };
  },
  components: { carMonthExport },
  // created(){
  // },
  watch: {
    'form.buyStartTime'() {
      const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
      if (
        this.form.buyStartTime != undefined &&
        this.form.buyStartTime != '' &&
        this.form.buyStartTime != null &&
        this.form.spaceId != ''
      ) {
        ruleIdColumn.disabled = false;
      } else {
        this.form.ruleId = '';
        ruleIdColumn.disabled = true;
      }
    },
    'form.spaceId'() {
      this.getAreNodeList(this.form.spaceId);
      //解决进入修改页面时，月客车规则下拉为空问题
      if (this.form.spaceId != null && this.form.spaceId != '' && this.form.spaceId != undefined) {
        monthChargeRuleList(Object.assign({ spaceId: this.form.spaceId })).then(({ data }) => {
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
        });
      }
    },
    'form.ruleId'() {
      const cycleNumColumn = this.findObject(this.option.column, 'cycleNum');
      //将时间格式转换为字串
      let buyStartTimeStr = this.form.buyStartTime + '';
      if (this.vdui.isNotEmpty(buyStartTimeStr) && this.vdui.isNotEmpty(this.form.ruleId)) {
        cycleNumColumn.disabled = false;
      } else {
        this.form.cycleNum = '';
        cycleNumColumn.disabled = true;
      }
    },
    'form.carClass'() {
      const remark1Column = this.findObject(this.option.column, 'remark1');
      if (this.form.carClass == 2) {
        remark1Column.rules[0].required = true;
        this.form.shouldMoney = 0;
        this.form.payMoney = 0;
      } else {
        remark1Column.rules[0].required = false;
        this.initShoudMoney();
      }
    },
    'form.cycleNum'() {
      this.initShoudMoney();
    },
    'carMonthCardPayForm.cycleNum'() {
      this.initShoudMoney_();
    },
    'carMonthReviewForm.buyStartTime'() {
      this.initShoudMoneyReview();
    },
    'carMonthReviewForm.ruleId'() {
      this.initShoudMoneyReview();
    },
    'carMonthReviewForm.cycleNum'() {
      this.initShoudMoneyReview();
    },
    'carMonthEditForm.buyStartTime'() {
      this.initShoudMoneyEdit();
    },
    'carMonthEditForm.ruleId'() {
      this.initShoudMoneyEdit();
    },
    'carMonthEditForm.cycleNum'() {
      this.initShoudMoneyEdit();
    },

    'form.shouldMoney'() {
      const column = this.findObject(this.option.column, 'shouldMoney');
      if (this.form.status == 3 || this.form.status == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    'form.payMoney'() {
      const column = this.findObject(this.option.column, 'payMoney');
      if (this.form.status == 3 || this.form.status == 2) {
        column.editDisabled = true;
      } else {
        column.editDisabled = false;
      }
    },
    //用于监听新增车场关联区域
    /* 'form.spaceId'(){
       this.form.regionId = '';
       let parkingLotIdTem = this.form.spaceId;
       if (this.vdui.isNotEmpty(parkingLotIdTem)) {
         this.getAreNodeList(this.form.spaceId);
       }
       nodeTreeByParentId(this.carMonthCopyForm.spaceId ).then((res) => {
         const column = this.findObject(this.carMonthCopyOption.column, 'regions');

         setTimeout(()=>{
           column.dicData = res.data;
         });
       })

     },*/

    //用于监听复制车场关联区域
    'carMonthCopyForm.spaceId'() {
      nodeTreeByParentId(this.carMonthCopyForm.spaceId).then((res) => {
        const column = this.findObject(this.carMonthCopyOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
    },
  },
  computed: {
    ...mapGetters(['permission']),
    ...mapGetters(['tagList']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthRenior_add, false),
        copyBtn: this.vaildData(this.permission.carmonth_copy, false),
        refundBtn: this.vaildData(this.permission.carmonth_refund_v1, false),
        contractBtn: this.vaildData(this.permission.carmonth_contract_v1, false),
        payBtn: this.vaildData(this.permission.carmonth_pay_v1, false),
        editBtn: this.vaildData(this.permission.carmonth_edit_v1, false),
        auditBtn: this.vaildData(this.permission.carmonth_audit_v1, false),
        delBtn: this.vaildData(this.permission.carmonth_del_v1, false),
      };
    },
    infoData() {
      return this.form.info;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    permissions() {
      return {
        propertyAmountCheck: this.vaildData(
          this.permission.propertyCharge_propertyAmountCheck,
          false
        ),
        otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
        proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
        byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
        byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
        byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
      };
    },

    payParams() {
      let params = this._.merge(
        {
          roomId: this.carMonthEditForm.communityId || '',
          roomName: this.carMonthCardPayForm.communityName || '',
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.carMonthCardPayForm.roomId ? this.zhxx.householder : '',
        },
        {
          payInfo: {
            //           "billTotalAmount": 5,
            // "preTotalAmount": 0,
            // "carTotalAmount": 0,
            // "temporaryTotalAmount": 0,
            // "totalShouldAmount": 5,
            // "accountAmount": 0,
            // "totalAccountpayAmount": 0,
            // "totalPayAmount": 5,
            // this.payInfo.totalPayAmount = NP.strip(
            //     this.totalShouldAmountCP - this.payInfo.totalAccountpayAmount
            //   );
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: 0,
            carTotalAmount: this.totalShouldAmountCP,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalShouldAmountCP,
            totalAccountpayAmount: 0,
            totalPayAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify([
              {
                feeType: 'carPay',
                feeName: this.carMonthCardPayForm.ruleName,
                feePeriod:
                  this.carMonthCardPayForm.buyStartTime +
                  ' - ' +
                  this.carMonthCardPayForm.buyEndTime,
                calAmount: this.totalShouldAmountCP,
                derateAmount: 0 + '',
                couponAmount: 0 + '',
                shouldAmount: this.totalShouldAmountCP + '',
              },
            ]),
          },
        }
      );
      params.carPay = this.carMonthCardPayForm;
      params.roomId = this.carMonthCardPayForm.communityId;
      params.roomName = this.carMonthCardPayForm.communityName;
      params.carPay.communityId = this.carMonthCardPayForm.spaceId;
      params.carPay.shouldAmount = this.totalShouldAmountCP;
      params.carPay.calAmount = this.totalShouldAmountCP;
      // params.carPay.payAmount = this.totalShouldAmountCP;
      params.carPay.backAmount = 0;

      return params;
    },

    billTotalAmountCP() {
      return Number(this.carMonthCardPayForm.shouldMoney);
    },
    totalShouldAmountCP() {
      return this.billTotalAmountCP;
    },
  },
  mounted() {},
  created() {
    //console.log(this.carMonthCopyOption);
    //console.log(carMonthCopyOption);
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[0].dicData = data.data;
        this.option.column[0].searchValue = this.spaceList[0].id;
        this.query.spaceId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
        monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
          console.log('monthcarStatusCount====>', data);
          this.statusCount.toPayNum = data.toPayNum;
          this.statusCount.toAuditNum = data.toAuditNum;
          this.statusCount.normalNum = data.normalNum;
          this.statusCount.expiredNum = data.expiredNum;
        });
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    //打印预览
    printprev() {
      this.$confirm('收费成功，是否需要打印收据？', '提示', {
        confirmButtonText: '打印',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (
            this.payInfo.payBillNo != ''
            // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
          ) {
            this.showMonthCarPayFlag = false;
            this.$refs.carMonthCardPayForm.resetForm();
            this.onLoad();

            this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
          } else {
            this.$message.warning('请先完成收款');
          }
        })
        .catch(() => {
          this.showMonthCarPayFlag = false;
          this.$refs.carMonthCardPayForm.resetForm();
          this.onLoad();
        });
    },
    //关闭二维码
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
      // if(this.payInfo2.tradeStatus === 2){
      //   console.log('success');
      // }else{
      //   window.location.reload();
      // }
    },
    confirmRoomSelection() {
      this.roomSelectionShowBoxFlag = false;
    },
    reviewConfirmRoomSelection() {
      this.reviewRoomSelectionShowBoxFlag = false;
    },
    editConfirmRoomSelection() {
      this.editRoomSelectionShowBoxFlag = false;
    },
    roomSelectionOpen() {
      this.roomSelectionShowBoxFlag = true;
    },
    reviewRoomSelectionOpen() {
      this.reviewRoomSelectionShowBoxFlag = true;
    },
    editRoomSelectionOpen() {
      this.editRoomSelectionShowBoxFlag = true;
    },
    cycleNumInput(val) {
      this.initShoudMoney_();
    },
    //初始化化应收金额
    initShoudMoneyEdit() {
      if (this.vdui.isNotEmpty(this.carMonthEditForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthEditForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.carMonthEditForm.ruleId,
          cycleNum: this.carMonthEditForm.cycleNum,
          startTime: this.carMonthEditForm.buyStartTime,
          backAmount: this.carMonthEditForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthEditForm.shouldMoney = data.shouldAmount;
          this.carMonthEditForm.payMoney = data.shouldAmount;
          this.carMonthEditForm.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.carMonthEditForm.shouldMoney) {
          this.carMonthEditForm.shouldMoney = 0;
        }
        if (!this.carMonthEditForm.payMoney) {
          this.carMonthEditForm.payMoney = 0;
        }
        return;
      }
    },
    //初始化化应收金额
    initShoudMoneyReview() {
      if (this.vdui.isNotEmpty(this.carMonthReviewForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthReviewForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.carMonthReviewForm.ruleId,
          cycleNum: this.carMonthReviewForm.cycleNum,
          startTime: this.carMonthReviewForm.buyStartTime,
          backAmount: this.carMonthReviewForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          this.carMonthReviewForm.shouldMoney = data.shouldAmount;
          this.carMonthReviewForm.payMoney = data.shouldAmount;
          this.carMonthReviewForm.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.carMonthReviewForm.shouldMoney) {
          this.carMonthReviewForm.shouldMoney = 0;
        }
        if (!this.carMonthReviewForm.payMoney) {
          this.carMonthReviewForm.payMoney = 0;
        }
        return;
        // this.form.shouldMoney = 0;
      }
    },
    //初始化化应收金额
    initShoudMoney_() {
      if (this.vdui.isNotEmpty(this.carMonthCardPayForm.cycleNum)) {
        if (this.vdui.isEmpty(this.carMonthCardPayForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.carMonthCardPayForm.ruleId,
          cycleNum: this.carMonthCardPayForm.cycleNum,
          //   startTime: this.carMonthCardPayForm.buyStartTime,
          startTime: this.carMonthCardPayForm.startTime,
          backAmount: this.carMonthCardPayForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          if (this.carMonthCardPayForm.carClass == 2) {
            this.carMonthCardPayForm.shouldMoney = 0;
            this.carMonthCardPayForm.payMoney = 0;
          } else {
            this.carMonthCardPayForm.shouldMoney = data.shouldAmount;
            this.carMonthCardPayForm.payMoney = data.shouldAmount;
          }
          this.carMonthCardPayForm.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.carMonthCardPayForm.shouldMoney) {
          this.carMonthCardPayForm.shouldMoney = 0;
        }
        if (!this.carMonthCardPayForm.payMoney) {
          this.carMonthCardPayForm.payMoney = 0;
        }
        return;
        // this.form.shouldMoney = 0;
      }
    },
    cancelPay() {
      this.showMonthCarPayFlag = false;
    },
    confirmPayAction() {
      console.log(this.payParams);
      // return;
      this.genearateQrCode();
    },

    //生成二维码
    genearateQrCode() {
      this.$refs.carMonthCardPayForm.validate((valid) => {
        if (valid) {
          // this.getBillFormData();
          this.payParams.payInfo.payType = this.carMonthCardPayForm.payType;
          this.payParams.payInfo.authCode = this.carMonthCardPayForm.authCode;
          console.log('this.carMonthCardPayForm.payType====>', this.carMonthCardPayForm.payType);
          if (parseInt(this.carMonthCardPayForm.payScene) == 5) {
            // 二维码
            this.qrCodePay();
          } else if (parseInt(this.carMonthCardPayForm.payScene) == 6) {
            // 扫码枪
            this.authCodePay();
          } else {
            // 现金
            this.normalPay();
          }
        }
      });
    },
    // 生成收款二维码
    qrCodePay() {
      saveCarQrCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.payBillNo;
          this.$nextTick(() => {
            new QRCode('qrcodeCar', {
              width: 250,
              height: 250,
              text: data.codeUrl,
            });
          });
          this.payInfo2.showQrCode = true;
          this.payInfo2.countdown = 120;
          this.payInfo2.timer = setInterval(() => {
            if (this.payInfo2.countdown === 0) {
              clearInterval(this.payInfo2.timer);
              this.payInfo2.showQrCode = false;
              this.$message.info('倒计时结束，二维码弹窗关闭');

              this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                confirmButtonText: '更新账单',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  // this.$message({
                  //     type: 'success',
                  //     message: '删除成功!'
                  // });
                  // this.printprev()
                  let { tag, key } = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                  this.$store.commit('DEL_TAG', tag);
                  this.$router.push({ path: `/v4ward/fundpay/fundpay-abnormal` });
                })
                .catch(() => {
                  // this.$message({
                  //     type: 'info',
                  //     message: '已取消删除'
                  // });
                  //重置数据
                  this.resetAllData();
                });

              // this.resetAllData();
              // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});
            }
            if (this.payInfo2.countdown % 5 === 0) {
              loadCarPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
                this.payInfo2.tradeStatus = data.tradeStatus;
                if (parseInt(data.tradeStatus) == 2) {
                  this.payInfo2.showQrCode = false;
                  this.$message.success('支付成功');
                  this.isSuccess = true;
                  clearInterval(this.payInfo2.timer);

                  // 可以打印
                  this.printprev();

                  // this.submitAllBill();
                }
              });
            }
            this.payInfo2.countdown--;
          }, 1000);
        }
      );
    },
    authCodePay() {
      saveCarBarCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
        ({ data }) => {
          // this.payInfo2.showQrCode = true;
          this.payInfo.payBillNo = data.payBillNo;
          this.isSuccess = true;
          this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
          console.log('data==>', data);
          // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
          if (data.payBillNo && data.isSuccess == 'false') {
            this.openMaskAndPollingPayStatus();
          } else {
            // 可以打印
            this.printprev();
            this.payInfo2.tradeStatus = 2;
          }
          // fix end
          // this.submitAllBill();
          //清楚数据
          // this.resetAllData();
        }
      );
    },

    normalPay() {
      this.submitAllBill();
      // saveQrCodePay_(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
      //     ({ data }) => {
      //     this.payInfo.payBillNo = data.payBillNo;
      //         loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
      //             this.payInfo2.tradeStatus = data.payStatus;
      //             if (parseInt(data.payStatus) == 1) {
      //             this.$message.success('支付成功');
      //             //重置数据
      //             this.resetAllData();
      //             // this.submitAllBill();
      //             }
      //         });
      //     }
      // );
    },
    //保存账单
    submitAllBill() {
      saveAllBill(this.payParams, { showLoading: { text: '处理中' } }).then(({ data, msg }) => {
        this.payInfo.payBillNo = data.payBillNo;
        this.isSuccess = data.isSuccess;
        this.$message.success(msg);
        this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
        // 可以打印
        this.printprev();
        //清楚数据
        // this.resetAllData();
      });
    },
    resetAllData() {
      location.reload();
    },
    // 扫码枪轮询
    openMaskAndPollingPayStatus() {
      this.statusDialogVisible = true;
      let timer = setInterval(() => {
        console.log('this.status==>', this.statusDuration);
        this.statusDuration--;
        console.log('this.status==>', typeof this.statusDuration);
        if (this.statusDuration <= 0) {
          this.$message.error('支付失败');
          this.statusDialogVisible = false;
          clearInterval(timer);
          this.statusDuration = 120;
          window.location.reload();
        } else {
          if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
            loadCarPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
              console.log('res pooling  data==>', data);
              if (data.tradeStatus === 2) {
                this.payInfo2.tradeStatus = data.tradeStatus;
                this.$message.success('支付成功');
                // 可以打印
                this.printprev();
                this.statusDialogVisible = false;
                clearInterval(timer);
                this.statusDuration = 120;
              }
            });
          }
        }
      }, 1000);
    },

    //选中
    confirmBillPay() {
      // this.payInfo.authCode
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.payBillList)) {
        this.$message.warning('请选择账单');
        return;
      }

      // let arrayLength = this.payBillList.length;
      // this.billPay.feeBillList.push(this.billPay.feeBillList[arrayLength-1]);
      // this.billPay.feeBillList[arrayLength-1].lockFlag = 1;
      console.log(this.payBillList);
      console.log(this.isPayBillLock(this.payBillList));

      let isLockedObject = this.isPayBillLock(this.payBillList);
      let self = this;

      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.payBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      // return;
      //   this.selected.billPay = true;
      this._.forEach(self.payBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'temporaryPay',
          feeName: item.billFeeItemName,
          feePeriod: item.billStartDate + ' - ' + item.billEndDate,
          calAmount: item.calAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
    },
    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        // const element = feeBillList[index];
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      // feeBillList.forEach((v,i)=>{
      //   console.log(v,i);
      // });
      return { isLock, index_: index_ };
    },
    payTypeChange(val) {
      if (val) {
        this.carMonthCardPayForm.payScene = '';
        // if(parseInt(val)==1){
        //     this.$refs.carMonthCardPayForm.columnOption[0].column[3].display=false;
        //     this.showAuthCodeFlag = false;
        //     this.$refs.carMonthCardPayForm.columnOption[0].column[2].display=false;
        // }else{
        //     this.showAuthCodeFlag = true;
        //     this.$refs.carMonthCardPayForm.columnOption[0].column[2].display=true;
        // }
        getPaySceneList({ payType: val }).then((res) => {
          this.paySceneList = res.data;
          console.log(res);
        });
      }
    },
    buildingIdChange(val) {
      console.log('buildingIdChange=====>', val);
      if (!val) {
        val = '';
      }
      loadRoomList({ propertyId: val }).then(({ data }) => {
        console.log(data);
        this.targetList = data;
        this.carMonthCardPayForm.roomId = '';
      });
    },

    targetIdChange(val) {
      loadZhxx({ roomId: val }).then(({ data }) => {
        this.zhxx = data[0];
        this.carMonthCardPayForm.areaName = data[0].roomName;
      });
    },
    // payTypeChange(val){
    //     if(val){
    //         this.carMonthCardPayForm.payScene = '';
    //         // if(parseInt(val)==1){
    //         //     this.$refs.carMonthCardPayForm.columnOption[0].column[3].display=false;
    //         //     this.showAuthCodeFlag = false;
    //         //     this.$refs.carMonthCardPayForm.columnOption[0].column[2].display=false;
    //         // }else{
    //         //     this.showAuthCodeFlag = true;
    //         //     this.$refs.carMonthCardPayForm.columnOption[0].column[2].display=true;
    //         // }
    //         getPaySceneList({payType:val}).then((res)=>{
    //             this.paySceneList = res.data;
    //             console.log(res);
    //         });
    //     }
    // },

    handlePayCarMonth(row, operateType) {
      this.operateType = operateType;
      let column = this.findObject(this.carMonthPayFormOption.column, 'cycleNum');
      if (this.operateType === 0) {
        this.payFormTitle = '付款';
        column.display = false;
      } else {
        this.payFormTitle = '续约';
        column.display = true;
      }
      let self = this;
      console.log('handlePayCarMonth=======>', row);
      getPayTypeList().then((res) => {
        console.log(res);
        this.payTypeList = res.data;
        getMonthcarDetail({ id: row.id, operateType: operateType }).then(({ data }) => {
          this.carMonthCardPayForm = {};
          this.carMonthCardPayForm.buyEndTime = '';
          this.carMonthCardPayForm = data;
          this.carMonthCardPayForm.payType = '';

          this.carMonthCardPayForm.cycleNum =
            dayjs(data.buyEndTime).diff(dayjs(data.buyStartTime), 'month') + 1;
          getParkSpaceList({ parentId: row.spaceId }).then(({ data }) => {
            console.log(data);
          });
          loadBuildingList({ propertyId: data.communityId }).then(({ data }) => {
            console.log(data);
            self.buildingList = data;
            self.targetList = [];
            self.carMonthCardPayForm.buildingId = '';
            self.carMonthCardPayForm.targetId = '';
          });
          this.initShoudMoney_();
          self.showMonthCarPayFlag = true;
        });
      });
    },
    selectTempStopUnPayList(spaceId, carNo) {
      // 查询临停欠费记录
      getListTempStopUnPayList({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
        ({ data }) => {
          this.unPayData = data;
        }
      );
      this.tempStopUnPayDialogFlag = true;
    },
    carNohandleBlur() {
      if (this.vdui.isNotEmpty(this.form.carNo)) {
        if (this.vdui.isNotEmpty(this.form.spaceId)) {
          let backAmountTemp = 0;
          this.form.customerPhone = '';
          this.form.customerName = '';
          this.form.lotNo = '';
          this.form.areaName = '';
          this.form.areaId = '';
          //查询欠费
          loadCarPayBackAmount({ communityId: this.form.spaceId, carNo: this.form.carNo }).then(
            ({ data }) => {
              backAmountTemp = Number(data.carPayBackAmount);
              //  start-----getcarMonthLastEndTime
              getcarMonthLastEndTime({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
                ({ data }) => {
                  if (this.vdui.isNotEmpty(data)) {
                    this.form.lastEndTime = data.buyEndTime;
                    this.form.buyStartTime = data.newStartTime + ' 00:00:00';
                    this.form.carType = data.carType;
                    if (this.vdui.isNotEmpty(data.regions)) {
                      this.form.regions = data.regions;
                    }
                    this.form.ruleId = data.ruleId;
                    this.form.backAmount = backAmountTemp;
                  } else {
                    let spaceIdTemp = this.form.spaceId;
                    let carNoTemp = this.form.carNo;
                    //若没查到则清空表单
                    this.emptyForm();
                    if (this.vdui.isEmpty(this.form.regions)) {
                      this.form.regions = this.regionFirstIdTemp;
                    }
                    if (backAmountTemp > 0) {
                      this.form.backAmount = backAmountTemp;
                    }
                    this.form.spaceId = spaceIdTemp;
                    this.form.carNo = carNoTemp;
                    this.form.buyStartTime = this.getInitData();
                  }
                }
              );
              //  end-----getcarMonthLastEndTime
            }
          );
        } else {
          this.$message.error('请先选择车场！');
          this.form.carNo = '';
        }
      } else {
        let spaceIdTemp = this.form.spaceId;
        this.emptyForm();
        this.form.spaceId = spaceIdTemp;
        this.form.buyStartTime = this.getInitData();
      }
    },
    // changeCarNohandleBlur() {
    //   if (this.vdui.isNotEmpty(this.carMonthChangeForm.carNo)) {
    //     if (this.vdui.isNotEmpty(this.carMonthChangeForm.spaceId)) {
    //       let backAmountTemp = 0;
    //       //查询欠费
    //       loadCarPayBackAmount({ communityId: this.carMonthChangeForm.spaceId, carNo: this.carMonthChangeForm.carNo }).then(
    //         ({ data }) => {
    //           backAmountTemp = Number(data.carPayBackAmount);
    //           //  start-----getcarMonthLastEndTime
    //           getcarMonthLastEndTime({ spaceId: this.carMonthChangeForm.spaceId, carNo: this.carMonthChangeForm.carNo }).then(
    //             ({ data }) => {
    //               if (this.vdui.isNotEmpty(data)) {
    //                 this.carMonthChangeForm.lastEndTime = data.buyEndTime;
    //                 if (this.vdui.isNotEmpty(data.regions)) {
    //                   this.carMonthChangeForm.regions = data.regions;
    //                 }
    //                 this.carMonthChangeForm.ruleId = data.ruleId;
    //                 this.carMonthChangeForm.backAmount = backAmountTemp;
    //               } else {
    //                 let spaceIdTemp = this.carMonthChangeForm.spaceId;
    //                 let carNoTemp = this.carMonthChangeForm.newCarNo;
    //                 //若没查到则清空表单
    //                 this.emptyForm();
    //                 if(this.vdui.isEmpty(this.carMonthChangeForm.regions)){
    //                   this.carMonthChangeForm.regions = this.regionFirstIdTemp;
    //                 }
    //                 if (backAmountTemp > 0) {
    //                   this.carMonthChangeForm.backAmount = backAmountTemp;
    //                 }
    //                 this.forcarMonthChangeFormm.spaceId = spaceIdTemp;
    //                 this.carMonthChangeForm.newCarNo = carNoTemp;
    //                 this.carMonthChangeForm.buyStartTime = this.getInitData();
    //               }
    //             }
    //           );
    //           //  end-----getcarMonthLastEndTime
    //         }
    //       );
    //     } else {
    //       this.$message.error('请先选择车场！');
    //       this.form.carNo = '';
    //     }
    //   } else {
    //     let spaceIdTemp = this.form.spaceId;
    //     this.emptyForm();
    //     this.form.spaceId = spaceIdTemp;
    //     this.form.buyStartTime = this.getInitData();
    //   }
    // },
    selectSpace() {
      // l临时变量
      let spaceIdTempOne = this.form.spaceId;
      this.emptyBasePerson();
      this.emptyForm();
      this.form.spaceId = spaceIdTempOne;
      const ruleIdColumn = this.findObject(this.option.column, 'ruleId');
      if (this.vdui.isNotEmpty(this.form.spaceId)) {
        if (this.form.buyStartTime != '') {
          ruleIdColumn.disabled = false;
        } else {
          this.form.ruleId = '';
          ruleIdColumn.disabled = true;
        }
        monthChargeRuleList(Object.assign({ spaceId: this.form.spaceId })).then(({ data }) => {
          if (data.length == 0) {
            this.$message.error('该车场下未查询到月卡车收费规则！');
          }
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
          /*if (this.vdui.isNotEmpty(this.form.carNo)) {
            getcarMonthLastEndTime({ spaceId: this.form.spaceId, carNo: this.form.carNo }).then(
              ({ data }) => {
                if (this.vdui.isNotEmpty(data)) {
                  this.form.lastEndTime = data.buyEndTime;
                  this.form.buyStartTime = data.newStartTime + ' 00:00:00';
                  this.form.carType = data.carType;
                  this.form.ruleId = data.ruleId;
                } else {
                  let spaceIdTemp = this.form.spaceId;
                 let carNoTemp = this.form.carNo;
                  //若没查到则清空表单
                  this.emptyForm();
                  this.form.spaceId = spaceIdTemp;
                  this.form.carNo = carNoTemp;
                }
              }
            );
          }*/
        });
      }
    },
    //初始化化应收金额
    initShoudMoney() {
      if (this.vdui.isNotEmpty(this.form.cycleNum)) {
        if (this.vdui.isEmpty(this.form.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.form.ruleId,
          cycleNum: this.form.cycleNum,
          startTime: this.form.buyStartTime,
          backAmount: this.form.backAmount,
          backType: 3,
        }).then(({ data }) => {
          //若为办公车则应收实收金额为0
          if (this.form.carClass == 2) {
            this.form.shouldMoney = 0;
            this.form.payMoney = 0;
          } else {
            this.form.shouldMoney = data.shouldAmount;
            this.form.payMoney = data.shouldAmount;
          }
          this.form.buyEndTime = data.endTime + ' 23:59:59';
        });
      } else {
        if (!this.form.shouldMoney) {
          this.form.shouldMoney = 0;
        }
        if (!this.form.payMoney) {
          this.form.payMoney = 0;
        }
        return;
        // this.form.shouldMoney = 0;
      }
    },
    //获取区域节点数据
    getAreNodeList(parentId) {
      this.form.regions = '';
      nodeTreeByParentId(parentId).then((res) => {
        const regionsColumn = this.findObject(this.option.column, 'regions');
        if (this.operateType === 'add') {
          this.form.regionId = '';
        }
        regionsColumn.dicData = res.data;
        if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(regionsColumn.dicData)) {
          if (this.addFlag) {
            this.form.regions = regionsColumn.dicData[0].id;
            // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
            this.regionFirstIdTemp = regionsColumn.dicData[0].id;
          } else {
            this.form.regions = '';
          }
        }
      });
    },
    //查询车牌号
    queryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({ communityId: this.form.spaceId, searchContent: qs }).then(
        ({ data }) => {
          if (this.vdui.isEmpty(data)) {
            cb([]);
            if (this.vdui.isNotEmpty(this.form.spaceId)) {
              this.$message.info('没有匹配到车辆信息！');
              this.form.carNo = '';
            }
          } else {
            this._.forEach(data, (item) => {
              item.value = item.carNo;
            });
            cb(data);
          }
        }
      );
    },
    changeQueryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({
        communityId: this.carMonthChangeForm.spaceId,
        searchContent: qs,
      }).then(({ data }) => {
        if (this.vdui.isEmpty(data)) {
          cb([]);
          if (this.vdui.isNotEmpty(this.carMonthChangeForm.spaceId)) {
            this.$message.info('没有匹配到车辆信息！');
            this.carMonthChangeForm.newCarNo = '';
          }
        } else {
          this._.forEach(data, (item) => {
            item.value = item.carNo;
          });
          cb(data);
        }
      });
    },
    //选择车牌号
    selectCarPayCarNo(item) {
      this.form.carNo = item.carNo;
      this.form.customerPhone = item.customerPhone;
      this.form.customerId = item.customerId;
      this.form.customerName = item.customerName;
      this.form.lotNo = item.lotNo;
      this.form.areaName = item.areaName;
      this.form.areaId = item.areaId;
    },
    //选择车牌号
    changeSelectCarPayCarNo(item) {
      this.carMonthChangeForm.newCarNo = item.carNo;
    },
    openCarMonthDeleteDialog(row) {
      if (row.$status !== '已过期') {
        this.$message.warning('请选择一条[已过期]数据进行操作');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return deleteCarMonth({ id: row.id });
        })
        .then(() => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
        });
    },
    //月卡车审核
    openCarMonthReviewDialog(form, done) {
      if (form.$status !== '待审核') {
        this.$message.warning('请选择一条[待审核]数据进行操作');
        return;
      }
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthReviewOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      monthChargeRuleList(Object.assign({ spaceId: form.spaceId })).then(({ data }) => {
        const column = this.findObject(this.carMonthReviewOption.column, 'ruleId');
        column.dicData = data;
      });
      this.carMonthReviewForm = form;
      this.carMonthReviewForm.cycleNum =
        dayjs(form.buyEndTime).diff(dayjs(form.buyStartTime), 'month') + 1;
      this.buyStartTimeTemp = this.carMonthReviewForm.buyStartTime;
      this.buyEndTimeTemp = this.carMonthReviewForm.buyEndTime;
      this.carMonthReviewShowDialogFlag = true;
    },
    //月卡车修改
    openCarMonthEditDialog(form, done) {
      if (form.$status !== '待审核') {
        this.$message.warning('请选择一条[待审核]数据进行操作');
        return;
      }
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthEditOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      monthChargeRuleList(Object.assign({ spaceId: form.spaceId })).then(({ data }) => {
        const column = this.findObject(this.carMonthEditOption.column, 'ruleId');
        column.dicData = data;
      });
      this.carMonthEditForm = form;
      this.carMonthEditForm.cycleNum =
        dayjs(form.buyEndTime).diff(dayjs(form.buyStartTime), 'month') + 1;
      this.buyStartTimeTemp = this.carMonthEditForm.buyStartTime;
      this.buyEndTimeTemp = this.carMonthEditForm.buyEndTime;
      this.carMonthEditShowDialogFlag = true;
    },

    quitCarMonthEditDialog(form, done) {
      this.carMonthEditShowDialogFlag = false;
      this.$refs.carMonthEditFormRef.resetForm();
    },
    quitCarMonthReviewDialog(form, done) {
      this.carMonthReviewShowDialogFlag = false;
      this.$refs.carMonthReviewFormRef.resetForm();
    },
    //审核通过
    carMonthReviewSubmit(form, done) {
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          //若为月卡车，则状态变为2：待付款
          form.status = 2;
          form.operateType = 1;
          update(form).then(
            () => {
              done();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              this.anewOnLoad();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    //审核驳回
    rejectCarMonthReviewDialog(form, done) {
      form = this.carMonthReviewForm;
      this.$refs.carMonthReviewFormRef.validate((valid) => {
        if (valid) {
          form.status = 1;
          form.operateType = 1;
          update(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.carMonthReviewShowDialogFlag = false;
              this.$refs.carMonthReviewFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    //月卡车牌变更
    openCarMonthChangeDialog(form, done) {
      this.carMonthChangeForm = form;
      this.carMonthChangeForm.newCarNo = '';
      this.carMonthChangeShowDialogFlag = true;
    },
    quitCarMonthChangeDialog(form, done) {
      this.carMonthChangeShowDialogFlag = false;
      this.$refs.carMonthChangeFormRef.resetForm();
    },
    carMonthChangeSubmit(form, done) {
      form.operateType = 3;
      if (form.carNo === form.newCarNo) {
        this.$message.success('输入新车牌号与修改前一样!');
        done();
        return;
      }
      form.newCarNo = form.newCarNo.trim();
      update(form).then(
        () => {
          this.anewOnLoad();
          this.$message.success('操作成功!');
          this.carMonthChangeShowDialogFlag = false;

          this.$refs.carMonthChangeFormRef.resetForm();
          done();
        },
        (error) => {
          console.log(error);
          done();
        }
      );
    },
    //月卡车退费
    openCarMonthRefundDialog(form, done) {
      if (form.$status !== '正常') {
        this.$message.warning('请选择一条[正常]数据进行操作！');
        return;
      }
      nodeTreeByParentId(form.spaceId).then((res) => {
        const column = this.findObject(this.carMonthRefundOption.column, 'regions');

        setTimeout(() => {
          column.dicData = res.data;
        });
      });
      monthChargeRuleList(Object.assign({ spaceId: form.spaceId })).then(({ data }) => {
        const column = this.findObject(this.carMonthRefundOption.column, 'ruleId');
        column.dicData = data;
        this.carMonthRefundForm = form;
        this.carMonthRefundShowDialogFlag = true;
        this.carMonthRefundForm.returnMoney = 1;
        this.carMonthRefundForm.endTime = form.buyEndTime;
        this.carMonthRefundForm.costPrice = data[0].costPrice;
      });
    },
    quitCarMonthRefundDialog(form, done, loading) {
      this.carMonthRefundShowDialogFlag = false;
      this.refundCheckReturnMoney = true;
      this.refundCheckBuyEndTime = true;
      this.$refs.carMonthRefundFormRef.resetForm();
    },
    carMonthRefundSubmit(form, done) {
      if (!this.refundCheckReturnMoney) {
        this.$message.error('请检查退费金额!');
        done();
        return;
      }
      if (!this.refundCheckBuyEndTime) {
        this.$message.error('请检查租赁止期!');
        done();
        return;
      }
      if (
        parseFloat(this.carMonthRefundForm.returnMoney).toFixed(2) >
        parseFloat(this.carMonthRefundForm.costPrice).toFixed(2)
      ) {
        this.$message.error('退费金额不能大于付款金额!');
        done();
        return;
      }
      form.operateType = 4;
      let dateStart = form.buyStartTime;
      let endTime = form.buyEndTime;
      let dateEnd = form.endTime;
      if (dateStart > endTime) {
        this.$message.error('结束时间必须大于等于租赁起期,小于等于租赁止期！');
        done();
        return;
      }
      if (endTime > dateEnd) {
        this.$message.error('结束时间必须大于等于租赁起期,小于等于租赁止期！');
        done();
        return;
      }
      update(form).then(
        () => {
          this.$message.success('操作成功!');
          done();
          this.carMonthRefundShowDialogFlag = false;
          this.$refs.carMonthRefundFormRef.resetForm();
          this.anewOnLoad();
        },
        (error) => {
          console.log(error);
          done();
        }
      );
    },
    rowSave(row, loading, done) {
      /*if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = this.regionFirstIdTemp;

      }*/

      addRenior(row).then(
        () => {
          this.$message.success('操作成功!');
          //清空上一表单数据
          let spaceIdTemp = this.form.spaceId;
          //this.form.regions = this.regionFirstIdTemp;
          this.form.regions = '';
          this.form.buyStartTime = this.getInitData();
          this.emptyForm();
          // 清空车主基本信息
          this.emptyBasePerson();
          this.form.spaceId = spaceIdTemp;
          this.onLoad();
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    //自定义清空表单
    emptyForm() {
      this.form.spaceId = '';
      this.form.carNo = '';
      this.form.carClass = 1;
      this.form.carType = '';
      this.form.lastEndTime = '';
      this.form.backAmount = 0;
      this.form.ruleId = '';
      this.form.cycleNum = '';
      this.form.buyEndTime = '';
      this.form.shouldMoney = 0;
      this.form.payMoney = 0;
      //this.form.regions = this.regionFirstIdTemp;
      this.form.regions = '';
      this.form.imgUrl = '';
      this.form.remark1 = '';
      this.form.buyStartTime = this.getInitData();
    },
    // 新增后，清空车主基本信息
    emptyBasePerson() {
      this.form.customerName = '';
      this.form.customerPhone = '';
      this.form.areaId = '';
      this.form.areaName = '';
      this.form.lotNo = '';
    },
    rowUpdate(row, index, loading, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        // console.log(row.imgUrl);
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          // console.log(row.imgUrl);
          this.onLoad();
          this.$message.success('操作成功!');
          loading();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openCarMonthSynDialog() {
      let exeFlag = true;
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      /*   this.selectionList.forEach((ele) => {
        if (ele.status != 3) {
          this.$message.error('请选择状态为正常的月卡车数据');
          exeFlag = false;
          return;
        }
      });*/
      for (let i = 0; i < this.selectionList.length; i++) {
        if (this.selectionList[i].status != 3) {
          this.$message.error('请选择状态为正常的月卡车数据');
          exeFlag = false;
          break;
        }
      }
      if (exeFlag) {
        this.$confirm('确定将选择进行同步?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return synchronize({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      }
    },
    // handlePayBtn(){
    //     this.showMonthCarPayFlag = true;
    // },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    beforeOpen(done, type) {
      //打开窗口前先将新增标识符置位false，后面根据打开的数新增窗口时将其置为true
      this.addFlag = false;
      const areaIdColumn = this.findObject(this.option.column, 'areaId');
      areaIdColumn.span = 16;
      areaIdColumn.label = '房间';

      if (['add'].includes(type)) {
        this.emptyForm();
        this.form.id = '';
        this.dialogDisabled = false;
        setTimeout(() => {
          this.form.lastEndTime = '';
          this.form.buyStartTime = this.getInitData();
          this.form.ruleId = '';
          this.form.carClass = 1;
          this.form.regions = '';
        }, 0);
        //打开的是新增页面标识
        this.addFlag = true;
      }
      if (['edit', 'view'].includes(type)) {
        //修改页面变更字段label名称
        areaIdColumn.span = 8;
        areaIdColumn.label = '修改房间';
        this.dialogDisabled = true;
        //  对历史数据造成的bug修改
        if (this.form.ruleId == -1) {
          this.form.ruleId = '';
        }
        this.form.backAmount = '';
        // 详情页展示操作日志
        if (['view'].includes(type)) {
          getDetailAndOperate({ id: this.form.id }).then(({ data }) => {
            this.form.info = data.carMonthLogList;
            setTimeout(() => {
              let _el = document.querySelector(
                'div[id*="el-collapse-content"] > div > div > div:nth-child(17) > div > div > div > div.avue-upload.avue-upload--list.avue-upload--upload > div.el-upload.el-upload--picture-img'
              );
              _el.style.display = 'inline-block';
              _el.addEventListener('click', (e) => {
                setTimeout(() => {
                  _el.querySelector('div>div>span>i').style.color = '#fff';
                });
              });
            });
          });
        }
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = this._.cloneDeep(data);
          if (this.vdui.isEmpty(this.form.backAmount)) {
            this.form.backAmount = 0;
          }
        });
      } else {
        setTimeout(() => {
          //console.log(this.query.parkingLotId);
          this.form.spaceId = this.query.spaceId;
        }, 0);
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
        console.log('monthcarStatusCount====>', data);
        this.statusCount.toPayNum = data.toPayNum;
        this.statusCount.toAuditNum = data.toAuditNum;
        this.statusCount.normalNum = data.normalNum;
        this.statusCount.expiredNum = data.expiredNum;
      });
      this.onLoad();
      done();
    },
    anewOnLoad() {
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (!this.query.spaceId) {
        this.query.spaceId = this.tempSpaceId;
      }
      monthcarStatusCount({ spaceId: this.query.spaceId }).then(({ data }) => {
        console.log('monthcarStatusCount====>', data);
        this.statusCount.toPayNum = data.toPayNum;
        this.statusCount.toAuditNum = data.toAuditNum;
        this.statusCount.normalNum = data.normalNum;
        this.statusCount.expiredNum = data.expiredNum;
      });
      this.onLoad();
    },
    selectionChange(list) {
      console.log('selectionChange(list) ===>', list);
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    getInitData() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (strDate < 10) {
        strDate = '0' + strDate;
      }
      var currentdate = year + '-' + month + '-' + strDate + ' 00:00:00';
      return currentdate;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.dateStartRange) {
        this.query.buyStartTimeStart = this.query.dateStartRange[0];
        this.query.buyStartTimeEnd = this.query.dateStartRange[1];
      }
      if (this.query.dateEndRange) {
        this.query.buyEndTimeStart = this.query.dateEndRange[0];
        this.query.buyEndTimeEnd = this.query.dateEndRange[1];
      }
      if (this.query.payTimeRange) {
        this.query.payTimeStart = this.query.payTimeRange[0];
        this.query.payTimeEnd = this.query.payTimeRange[1];
      }
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      if (this.spaceList.length > 0) {
        // getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        getMonthcarList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.spaceId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    //打开导出弹框
    openExportExcelDialog() {
      this.exportExcelFlag = true;
      this.$refs.exportExcelFormRef.resetForm();
    },
    //按条件导出
    exportExcel(form, done) {
      var values = { ...form };
      const { dateStartRange, dateEndRange } = form;
      if (dateStartRange) {
        values = {
          ...form,
          buyStartTimeStart: dateStartRange[0],
          buyStartTimeEnd: dateStartRange[1],
        };
        values.dateStartRange = null;
        this.form.dateStartRange = null;
      }
      if (dateEndRange) {
        values = { ...form, buyEndTimeStart: dateEndRange[0], buyEndTimeEnd: dateEndRange[1] };
        values.outTime = null;
        this.form.dateEndRange = null;
      }
      this.$refs.carMonthExport.carMonthExportExcel(values);
      done();
    },
    uploadBefore(file, done, loading) {
      // console.log(file.name.split('.'));
      let len = file.name.split('.').length;
      // console.log(file.name.split('.')[len-1]);
      console.log(
        file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
      );
      console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },

    //打开复制月卡车弹框
    openCarmonthCopyDialog() {
      this.carMonthCopyShowDialogFlag = true;
      console.log(this.selectionList.length);
      if (this.selectionList.length == 0) {
        this.$message.warning('请最少选择一条需要复制的车辆');
        this.carMonthCopyShowDialogFlag = false;
        return;
      }
      //初始化复制月卡车页面
      //this.carMonthCopyForm = this.deepClone(this.selectionList[0]);
      this.carMonthCopyForm.spaceId = this.selectionList[0].parkingLotId;

      //用于复制月卡车页面区域数据
      //console.log("this.selectionList[0].spaceId===>",this.selectionList[0].spaceId);
      nodeTreeByParentId(this.selectionList[0].spaceId).then((res) => {
        const column = this.findObject(this.carMonthCopyOption.column, 'regions');
        console.log(column);
        setTimeout(() => {
          column.dicData = res.data;
        });

        /*if (this.vdui.isEmpty(this.form.regions) && this.vdui.isNotEmpty(column.dicData)) {
          if (this.addFlag) {
            this.form.regions = column.dicData[0].id;
            // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
            this.regionFirstIdTemp = column.dicData[0].id;
          } else {
            this.form.regions = '';
          }
        }*/
      });
    },
    //退出复制月卡车
    quitCarMonthCopyDialog(form, done) {
      this.carMonthCopyShowDialogFlag = false;
      this.$refs.CarMonthCopyFormRef.resetForm();
      this.onLoad();
    },

    //复制月卡车保存
    carMonthCopySubmit(form, done) {
      //console.log(form);
      //console.log(this.selectionList);
      let idList = [];
      this.selectionList.forEach((e, i) => {
        idList.push(e.id);
      });

      //console.log(form.regions.length);

      let form_ = {
        ids: idList.join(','),
        spaceId: form.spaceId,
        //regionId:form.regions.length || '',
        regionId: form.regions.length == 0 ? '' : form.regions,
      };
      //console.log(form_);
      // return;
      //调用复制月卡车凭证接口
      copyCarmonth(form_).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.carMonthCopyShowDialogFlag = false;
          this.$refs.carMonthCopyFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },

    carMonthEditSubmit(row, done) {
      if (this.vdui.isEmpty(row.regions) || row.regions.size < 0) {
        row.regions = '';
      }
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.quitCarMonthEditDialog();
          this.emptyForm();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
  },
};
</script>

<style></style>
